(() => {
   window.__vnk_storefront_token__ = window.__vnk_storefront_token__ || '91ea46edea272a27f73c95c733f16762';

   window.__vnk_filters__ = window.__vnk_filters__ || {};
   window.__vnk_filters__.collection = window.__vnk_filters__.collection || 'all';
   window.__vnk_filters__.face       = window.__vnk_filters__.face       || 'all'; 
   window.__vnk_filters__.occasion   = window.__vnk_filters__.occasion   || 'all';
   window.__vnk_filters__.neckline   = window.__vnk_filters__.neckline   || 'all';


const DEBUG = false;
const log = (...a) => DEBUG && console.log('[earring-sg]', ...a);

// --- Helpers ---
const VNK_STYLE_KEY = 'vnk_style_profile';

window.saveStyleProfile = function ({ face, collection, title, subtitle }) {
  const prev = (() => {
    try { return JSON.parse(localStorage.getItem(VNK_STYLE_KEY)) || {}; }
    catch { return {}; }
  })();

  localStorage.setItem(
    VNK_STYLE_KEY,
    JSON.stringify({
      face: face || prev.face || null,
      last_collection: collection ?? prev.last_collection ?? null,
      title: title || prev.title || null,
      subtitle: subtitle || prev.subtitle || null,
      detected_at: prev.detected_at || Date.now()
    })
  );
};


window.loadStyleProfile = function () {
  try {
    const raw = localStorage.getItem(VNK_STYLE_KEY);
    if (!raw) return null;

    const profile = JSON.parse(raw);
    if (!profile || !profile.detected_at) return null;

    const MAX_AGE_DAYS = 7;
    const ageMs = Date.now() - profile.detected_at;
    const maxAgeMs = MAX_AGE_DAYS * 24 * 60 * 60 * 1000;

    if (ageMs > maxAgeMs) {
      localStorage.removeItem(VNK_STYLE_KEY);
      return null;
    }

    return profile;
  } catch {
    return null;
  }
};




  // --- Helpers ---
  const waitFor = (fn, { interval = 120, timeout = 12000 } = {}) =>
    new Promise((res, rej) => {
      const t0 = Date.now();
      (function poll() {
        try {
          const v = fn();
          if (v) return res(v);
          if (Date.now() - t0 > timeout) return rej(new Error('Timeout'));
          setTimeout(poll, interval);
        } catch (e) { rej(e); }
      })();
    });

  function getCollectionsMap(root) {
    try {
      if (root && root.dataset && root.dataset.collections) return JSON.parse(root.dataset.collections);
    } catch (e) { log('getCollectionsMap parse err', e); }
    return {};
  }

  function randomId(len = 6) { return Math.random().toString(36).substring(2, 2 + len); }

  // capture a frame from a video element and return a Blob; optional downscale
  async function captureFrameBlob(video, downscaleTo = 1024) {
    log('Capturing frame…', video && video.videoWidth, video && video.videoHeight);
    const w = video.videoWidth || 1280;
    const h = video.videoHeight || 720;
    const scale = downscaleTo ? Math.min(1, downscaleTo / Math.max(w, h)) : 1;
    const sw = Math.round(w * scale), sh = Math.round(h * scale);

    const shot = document.createElement('canvas');
    shot.width = sw; shot.height = sh;
    const c = shot.getContext('2d');
    // mirror so selfies remain correct
    c.translate(shot.width, 0); c.scale(-1, 1);
    c.drawImage(video, 0, 0, shot.width, shot.height);
    return new Promise(res => shot.toBlob(res, 'image/jpeg', 0.85));
  }

  // ---------- Modal helpers ----------
  
  function showPreviewModal(
  dataUrl,
  {
    title = 'Here’s your preview!',
    subtitle = 'Preview of the face you captured',
    autoCloseMs = null,
    collHandle = null
  } = {}
)
 {
  // remove existing modal if any
  const exist = document.getElementById('vnk-cartoon-modal');
  if (exist) try { exist.parentElement.removeChild(exist); } catch (e) {}

  return new Promise((resolve) => {
    const modal = document.createElement('div');
    modal.id = 'vnk-cartoon-modal';

    // Modal markup now includes a header with Back + Title + Close
    modal.innerHTML = `
      <div id="vnk-cartoon-card" role="dialog" aria-modal="true">
       
        <!-- Captured face image -->
        ${dataUrl ? `<img id="vnk-cartoon-img" src="${dataUrl}" alt="Captured face" />` : ``}
        

        ${dataUrl ? '' : '<div class="vnk-welcome-back">Welcome back!!</div>'}


        <!-- Style signature title -->
        <div id="vnk-cartoon-title">${title}</div>

        <!-- Result text (style message + celeb match) -->
        <div id="vnk-result">${subtitle}</div>

        <!-- Tabs -->
        <div class="vnk-tabs">
          <div class="vnk-tab active" data-handle="">For You</div>
          <div class="vnk-tab" data-handle="">Earrings</div>
          <div class="vnk-tab" data-handle="">Earring | Pendant</div>
          <div class="vnk-tab" data-handle="">Earring | Bracelet</div>
          <div class="vnk-tab">Jewelry Set</div>
        </div>

        <!-- Carousel slot -->
        <div id="vnk-carousel-slot" aria-live="polite"></div>

        <!-- CTA button -->
        <div class="vnk-cta" id="vnk-cta-btn">Shop More like this →</div>

      </div>
    `;

    const host = document.querySelector('#vnk-float .vnk-ear-content');
    (host || document.body).appendChild(modal);

  // Collection tab initializer — preserves face filter (paste after modal appended)
(function initCollectionTabs_preserveFace(){
  const mapping = {
    'Earrings': 'earrings',
    'Earring | Pendant': 'earring-pendant',
    'Earring | Bracelet': 'earring-bracelet',
    'Jewelry Set': 'jewelry-sets',
    'For You': ''
  };
  const collRow = modal.querySelector('.vnk-tabs') || document.querySelector('.vnk-tabs');
  if (!collRow) return;
  if (collRow.dataset.vnkCollectionInit === '1') return;
  collRow.dataset.vnkCollectionInit = '1';

  // remove old listeners by cloning nodes (idempotent)
  Array.from(collRow.querySelectorAll('.vnk-tab')).forEach(tab => {
    const clone = tab.cloneNode(true);
    tab.parentNode.replaceChild(clone, tab);
  });

  const tabs = Array.from(collRow.querySelectorAll('.vnk-tab'));
  tabs.forEach(tab => {
    const label = (tab.getAttribute('data-handle') || tab.textContent || '').trim();
    const mapped = tab.dataset.collectionHandle || mapping[label] || '';
    tab.dataset.collectionHandle = mapped;

    tab.addEventListener('click', async () => {
      // UI single-select (do not toggle off)
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // ensure filter object exists and preserve face
      window.__vnk_filters__ = window.__vnk_filters__ || {};
      if (window.__vnk_last_face_type__) {
        window.__vnk_filters__.face = String(window.__vnk_last_face_type__).toLowerCase();
      }

      const handle = mapped || '';
      window.__vnk_filters__.collection = handle;
      window.__vnk_last_coll_handle__ = handle;

      // Fetch collection then apply filters (so product.metafields are available for matching)
      try { if (handle && typeof renderCarouselForCollection === 'function') await renderCarouselForCollection(handle); } catch(e){ console.error(e); }
      try {
        if (typeof applyFiltersAndRender === 'function') applyFiltersAndRender();
        else {
          const cta = document.getElementById('vnk-cta-btn');
          if (cta && typeof buildTempCTA === 'function') {
            const url = buildTempCTA(handle, window.__vnk_filters__ || {});
            if (url) cta.dataset.vnkTempHref = url;
          }
        }
      } catch(e){ console.error(e); }
    }, false);
  });
})();
  

    // Insert neckline + occasion tab containers (only once)
(function injectFilterRows() {
  const tabsWrap = modal.querySelector('.vnk-tabs');
  if (!tabsWrap) return;
  if (!modal.querySelector('#vnk-neckline-tabs')) {
    const n = document.createElement('div');
    n.className = 'vnk-tabs';
    n.id = 'vnk-neckline-tabs';
    n.style.display = 'none';
    tabsWrap.after(n);
  }
  if (!modal.querySelector('#vnk-occasion-tabs')) {
    const o = document.createElement('div');
    o.className = 'vnk-tabs';
    o.id = 'vnk-occasion-tabs';
    o.style.display = 'none';
    const neck = modal.querySelector('#vnk-neckline-tabs');
    (neck || tabsWrap).after(o);
  }
})();


    // local remove helper (clean removal)
    function removeModal() {
      try { if (modal && modal.parentElement) modal.parentElement.removeChild(modal); } catch (e) {}
    }
    // expose global close helper for other code paths
    window.closeCartoonModal = function () { try { removeModal(); } catch (e) {} };

    // wire header buttons (minimal, defensive)

    const cta = modal.querySelector('#vnk-cta-btn');
    const root = document.getElementById('vnk-float');

   

    if (cta) {
  cta.addEventListener('click', () => {
    const url = cta.dataset.vnkTempHref || (collHandle ? `/collections/${encodeURIComponent(collHandle)}` : null);
    if (url) window.location.href = url;
  });
}


    if (autoCloseMs && Number(autoCloseMs) > 0) {
      setTimeout(removeModal, autoCloseMs);
    }

    resolve(modal);
  });
}

  /* ========= Minimal VNK filter helpers (DROP-IN) ========= */
 // simple state for active filters
window.__vnk_filters__ = window.__vnk_filters__ || { collection: '', face: '', neckline: '', occasion: '' };

 // utility: normalize and split metafield-like values (handles comma lists)

// extract unique options from products for a metafield name (e.g. 'necklines' or 'occasions')
function extractUniqueOptions(products, fieldName, limit) {
  const out = new Set();
  products.forEach(p => {
    try {
      const raw = (p && p.metafields && p.metafields.custom && p.metafields.custom[fieldName]) || '';
      _parseMetaValues(raw).forEach(v => out.add(String(v).toLowerCase()));
    } catch(e) {}
  });
  return Array.from(out).slice(0, (limit || 10));
}

// render a row of vnk-tabs for given options into given container id
function renderFilterTabs(containerId, options, groupName) {
  const container = document.getElementById(containerId);
  if (!container) return;
  container.innerHTML = ''; // reset
  options.forEach(opt => {
    const d = document.createElement('div');
    d.className = 'vnk-tab';
    d.setAttribute('data-vnk-group', groupName);
    d.setAttribute('data-vnk-value', opt);
    d.textContent = opt.replace(/-/g,' ').replace(/\b\w/g, s => s.toUpperCase()); // prettify
    container.appendChild(d);
  });
  // attach single-select behavior
  container.querySelectorAll('.vnk-tab').forEach(tab => {
    tab.addEventListener('click', (e) => {
      // single select: remove active from siblings
      container.querySelectorAll('.vnk-tab').forEach(s => s.classList.remove('active'));
      // toggle this one
      const isActive = tab.classList.toggle('active');
      // update state (only 1 allowed)
      window.__vnk_filters__[groupName] = isActive ? tab.dataset.vnkValue : '';
      // re-run filtering render
      applyFiltersAndRender();
    }, { passive: true });
  });
}


// ---------------- Canonical helper: parse comma/list-like metafield values ----------------
function _parseMetaValues(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map(String).map(s => s.trim()).filter(Boolean);
  // allow both 'a, b' and ['a','b'] forms; handle empty strings gracefully
  return String(raw).split(',').map(s => s.trim()).filter(Boolean);
}

// normalize a raw metafield value into a comma-separated, lowercased string
function normalizeMetafieldValue(raw, type) {
  if (!raw && raw !== 0) return '';
  let v = raw;

  // If the value looks like a JSON array string, parse it
  if (typeof v === 'string') {
    const trimmed = v.trim();
    if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || trimmed.startsWith('{"')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.map(x => String(x || '').toLowerCase().trim()).filter(Boolean).join(',');
        }
        // if parsed is object, fall back to string
        v = String(parsed);
      } catch (e) {
        // not JSON, continue
      }
    }
    // if comma-separated string already
    if (trimmed.indexOf(',') !== -1) {
      return trimmed.split(',').map(s => s.trim().toLowerCase()).filter(Boolean).join(',');
    }
    // otherwise single token
    return trimmed.toLowerCase();
  }

  // If it's an array already
  if (Array.isArray(v)) {
    return v.map(x => String(x || '').toLowerCase().trim()).filter(Boolean).join(',');
  }

  // fallback to string
  return String(v).toLowerCase().trim();
}


// ---------------- Robust filterProducts (single source of truth) ----------------
function filterProducts(products = [], filters = {}) {
  // defensive defaults
  filters = filters || {};
  const wantFace = (filters.face || 'all').toString().toLowerCase();
  const wantCollection = (filters.collection || 'all').toString().toLowerCase();
  const wantOccasion = (filters.occasion || filters.occasions || 'all').toString().toLowerCase();
  const wantNeckline = (filters.neckline || filters.necklines || 'all').toString().toLowerCase();

  // helper: returns true if product matches a comma-list meta value for the desired token
  const matchesMetaList = (metaRaw, desired) => {
    if (!desired || desired === 'all') return true; // wildcard: always matches
    if (!metaRaw) return false;
    const arr = _parseMetaValues(metaRaw).map(x => String(x || '').toLowerCase());
    return arr.includes(desired);
  };

  // helper: collection match
  const matchesCollection = (prodHandleOrCollectionField, desiredColl) => {
    if (!desiredColl || desiredColl === 'all') return true;
    // your products may not carry collection handle; higher-level code already filters by fetch source
    // if product has a 'collection' field use it, otherwise try to match by passed collection handle in filters
    // Here we'll assume top-level matching by filter.collection is handled outside; return true to be permissive.
    return true;
  };

  return products.filter(p => {
    // face filter
    if (!matchesMetaList((p.metafields && p.metafields.custom && p.metafields.custom.face_type) || '', wantFace)) {
      return false;
    }
    // occasion filter
    if (!matchesMetaList((p.metafields && p.metafields.custom && p.metafields.custom.occasions) || '', wantOccasion)) {
      return false;
    }
    // neckline filter
    if (!matchesMetaList((p.metafields && p.metafields.custom && p.metafields.custom.necklines) || '', wantNeckline)) {
      return false;
    }
    // collection filter: if filter is 'all' accept; otherwise ensure product belongs to the collection.
    if (wantCollection !== 'all') {
      // two ways we can check:
      // 1) if product has a collection_handle property (rare), match it
      if (p.collection_handle && String(p.collection_handle).toLowerCase() !== wantCollection) return false;
      // 2) otherwise — when rendering by collection we already fetched the collection's products, so allow pass-through
      // If you need stricter matching across mixed sources, implement mapping of product->collection during fetch.
    }
    // passed all active filters
    return true;
  });
}


// ---------------- applyFiltersAndRender (single authoritative render) ----------------
function applyFiltersAndRender() {
  try {
    const coll = window.__vnk_last_coll_handle__ || (window.__vnk_filters__ && window.__vnk_filters__.collection) || '';
    const products = (window.__vnk_last_fetched_products__ || []).slice();
    if (!products.length) return; // nothing to filter yet

    window.__vnk_filters__ = window.__vnk_filters__ || {};
    if (window.__vnk_last_face_type__) window.__vnk_filters__.face = window.__vnk_last_face_type__;

    const filtered = filterProducts(products, window.__vnk_filters__);

    // explicit no-results
    if (!filtered.length) {
      const slot = document.querySelector('#vnk-cartoon-modal #vnk-carousel-slot') || document.getElementById('vnk-carousel-slot');
      if (slot) slot.innerHTML = `<div style="padding:16px;color:#666">No products match your filters.</div>`;
      const cta = document.getElementById('vnk-cta-btn');
      if (cta) cta.dataset.vnkTempHref = '';
      return;
    }

    // Render using existing helper (keeps UI unchanged)
    if (typeof renderCarouselFromProducts === 'function') {
      renderCarouselFromProducts(filtered, coll || '');
    } else {
      // fallback: reuse existing renderer pattern (should not be necessary)
      renderCarouselFromProducts(filtered, coll || '');
    }

    // update CTA
    const cta = document.getElementById('vnk-cta-btn');
    const url = buildTempCTA(coll || '', window.__vnk_filters__);
    if (cta && url) cta.dataset.vnkTempHref = url;
  } catch (err) {
    console.error('applyFiltersAndRender', err);
  }
}

// expose helpers globally for console/testing and external callers
window._parseMetaValues = _parseMetaValues;
window.filterProducts = filterProducts;
window.applyFiltersAndRender = applyFiltersAndRender;


// create a temp CTA URL encoding active filters (keeps simple, readable)
function buildTempCTA(collHandle, filters) {
  if (!collHandle) return null;
  const params = new URLSearchParams();
  if (filters && filters.face) params.set('vnk_face', filters.face);
  if (filters && filters.neckline) params.set('vnk_neckline', filters.neckline);
  if (filters && filters.occasion) params.set('vnk_occasion', filters.occasion);
  const qs = params.toString();
  return qs ? `/collections/${encodeURIComponent(collHandle)}?${qs}` : `/collections/${encodeURIComponent(collHandle)}`;
}

/* ---------- enrichProductsWithMeta: ensure metafields.custom.face_type/necklines/occasions exist ---------- */
async function enrichProductsWithMeta(products, collectionHandle) {
  // copy so we don't mutate original input unexpectedly
  let out = (products || []).map(p => Object.assign({}, p));

  // 1) try to find vnk-products-json snippet(s) on the page and map by handle
  function getVnkSnippetMap() {
    try {
      const scripts = Array.from(document.querySelectorAll('script[type="application/json"][id^="vnk-products-json"]'));
      if (!scripts.length) return null;
      const map = {};
      for (const s of scripts) {
        try {
          const obj = JSON.parse(s.textContent || '{}');
          if (!obj || !obj.collection_handle || !Array.isArray(obj.products)) continue;
          for (const p of obj.products) {
            // map by handle (lowercase)
            if (p.handle) map[String(p.handle).toLowerCase()] = p;
          }
        } catch (e) { /* ignore bad json */ }
      }
      return Object.keys(map).length ? map : null;
    } catch (e) { return null; }
  }

  const vnkMap = getVnkSnippetMap();

  // helper parse "comma or array" into array
  function _parseMetaValuesLocal(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.map(String).map(s => s.trim()).filter(Boolean);
    return String(raw).split(',').map(s => s.trim()).filter(Boolean);
  }

  // helper: try to extract metadata from product tags (if merchant encoded them)
  function parseMetaFromTags(p) {
    const meta = { face_type: '', necklines: '', occasions: '' };
    try {
      const tags = (p.tags || p.tag_list || []).slice ? p.tags : (p.tags ? String(p.tags).split(',') : []);
      // build a simple map by normalizing tag text "key:value" or known keywords
      for (let t of tags) {
        t = String(t || '').trim();
        if (!t) continue;
        // key:value pattern
        const kv = t.split(':').map(x => x.trim());
        if (kv.length >= 2) {
          const k = kv[0].toLowerCase();
          const v = kv.slice(1).join(':'); // in case value contains ':'
          if (k.indexOf('face') !== -1) meta.face_type = meta.face_type ? `${meta.face_type},${v}` : v;
          else if (k.indexOf('neck') !== -1) meta.necklines = meta.necklines ? `${meta.necklines},${v}` : v;
          else if (k.indexOf('occasion') !== -1 || k.indexOf('occa') !== -1) meta.occasions = meta.occasions ? `${meta.occasions},${v}` : v;
          else {
            // fallback: treat some tags as possible face types (e.g., "oval", "round")
            const low = v.toLowerCase();
            if (['oval','round','square','rectangle','diamond','heart'].includes(low)) {
              meta.face_type = meta.face_type ? `${meta.face_type},${low}` : low;
            }
          }
        } else {
          // single token tag: check if it matches known face types or necklines or occasions heuristics
          const rawTag = t.toLowerCase();
          if (['oval','round','square','rectangle','diamond','heart'].includes(rawTag)) {
            meta.face_type = meta.face_type ? `${meta.face_type},${rawTag}` : rawTag;
          } else if (rawTag.match(/v-?neck|crew|boat|scoop|sweetheart|halter|off-?shoulder|collared/)) {
            meta.necklines = meta.necklines ? `${meta.necklines},${rawTag}` : rawTag;
          } else if (rawTag.match(/wedding|party|casual|office|festive|bridal/)) {
            meta.occasions = meta.occasions ? `${meta.occasions},${rawTag}` : rawTag;
          }
        }
      }
    } catch (e) { /* ignore */ }
    // collapse duplicates, normalize
    const dedupe = arr => Array.from(new Set(arr.filter(Boolean).map(s => s.toString().toLowerCase())));
    meta.face_type = dedupe(_parseMetaValuesLocal(meta.face_type)).join(',');
    meta.necklines = dedupe(_parseMetaValuesLocal(meta.necklines)).join(',');
    meta.occasions = dedupe(_parseMetaValuesLocal(meta.occasions)).join(',');
    return meta;
  }

  // 2) try GraphQL fetch to get metafields for all products (optional, only if token provided)
  async function fetchMetafieldsByHandles(handles) {
    // requires you to set window.__vnk_storefront_token__ on the page (storefront API token)
    const token = window.__vnk_storefront_token__ || '';
    if (!token) return null;
    try {
      // Build GraphQL query: fetch first 50 products by handle (adjust if needed)
      const queries = handles.map((h, i) => `p${i}: productByHandle(handle: "${h}") { handle id metafields(first:10) { edges { node { key namespace value type } } }}`);
      const body = `{ ${queries.join('\n')} }`;
      const res = await fetch('/api/2024-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: body })
      });
      if (!res.ok) return null;
      const json = await res.json();
      if (!json || !json.data) return null;
      // convert result map into { handle: { metafields ... } }
      const map = {};
      for (const k of Object.keys(json.data)) {
        const node = json.data[k];
        if (!node || !node.handle) continue;
        const mf = {};
        if (node.metafields && node.metafields.edges && node.metafields.edges.length) {
          for (const e of node.metafields.edges) {
            const n = e.node;
            if (!n) continue;
            // namespace:key -> value
            const key = n.key;
            mf[key] = n.value;
          }
        }
        map[String(node.handle).toLowerCase()] = mf;
      }
      return map;
    } catch (e) {
      console.warn('GraphQL metafield fetch failed', e);
      return null;
    }
  }

  // perform enrichment loop
  const handles = out.map(p => String(p.handle || p.handle || '').toLowerCase()).filter(Boolean);
  // Prepare potential map from snippet
  const snippetMap = vnkMap; // may be null

  // if GraphQL token present, try to fetch metafields for these handles
  const graphqlMap = (window.__vnk_storefront_token__ && handles.length) ? await fetchMetafieldsByHandles(handles) : null;

  // now merge per-product
  out = out.map(p => {
    try {
      p.metafields = p.metafields || {};
      p.metafields.custom = p.metafields.custom || {};

      const handle = String(p.handle || '').toLowerCase();

      // 1) if snippet exists and has this handle — copy fields
      if (snippetMap && snippetMap[handle]) {
        const sp = snippetMap[handle];
        // snippet fields: face_type, necklines, occasions (already normalized by Liquid)
        if (sp.face_type) p.metafields.custom.face_type = String(sp.face_type).trim();
        if (sp.necklines) p.metafields.custom.necklines = String(sp.necklines).trim();
        if (sp.occasions) p.metafields.custom.occasions = String(sp.occasions).trim();
      }

      // 2) if not found, and REST product has some top-level fields (rare), copy them
      if (!p.metafields.custom.face_type && p.face_type) p.metafields.custom.face_type = String(p.face_type);
      if (!p.metafields.custom.necklines && p.necklines) p.metafields.custom.necklines = String(p.necklines);
      if (!p.metafields.custom.occasions && p.occasions) p.metafields.custom.occasions = String(p.occasions);

      // 3) try tags-based parse if still empty
      const needFace = !p.metafields.custom.face_type;
      const needNeck = !p.metafields.custom.necklines;
      const needOcc  = !p.metafields.custom.occasions;
      if ((needFace || needNeck || needOcc) && (p.tags || p.tag_list)) {
        const parsed = parseMetaFromTags(p);
        if (needFace && parsed.face_type) p.metafields.custom.face_type = parsed.face_type;
        if (needNeck && parsed.necklines) p.metafields.custom.necklines = parsed.necklines;
        if (needOcc  && parsed.occasions) p.metafields.custom.occasions = parsed.occasions;
      }

      // 4) GraphQL fallback fields (if present)
      if (graphqlMap && graphqlMap[handle]) {
        const gm = graphqlMap[handle];
        // common key names might be 'face_type', 'necklines', 'occasions' under namespace 'custom'
        if (!p.metafields.custom.face_type && gm['face_type']) p.metafields.custom.face_type = gm['face_type'];
        if (!p.metafields.custom.necklines && (gm['necklines'] || gm['neckline'])) p.metafields.custom.necklines = gm['necklines'] || gm['neckline'];
        if (!p.metafields.custom.occasions && gm['occasions']) p.metafields.custom.occasions = gm['occasions'];
      }

      // final normalize: ensure strings and comma lists
      ['face_type','necklines','occasions'].forEach(k => {
        let v = p.metafields.custom[k] || '';
        // sometimes GraphQL returns JSON arrays, handle that
        if (Array.isArray(v)) v = v.join(',');
        if (typeof v !== 'string') v = String(v || '');
        p.metafields.custom[k] = _parseMetaValuesLocal(v).map(x => x.toString().toLowerCase()).join(',');
      });

    } catch (e) { /* ignore per-product errors */ }
    return p;
  });

  return out;
}


  // small helper that uses the same slide markup logic but from an in-memory products array
  function renderCarouselFromProducts(products, collHandle) {
  // reuse the id/slider init logic used earlier: create a temporary ai_gen_id and build wrapper same way
  const ai_gen_id = 'dyn_filtered_' + (Math.random().toString(36).slice(2,9));
  const common = (name, id) => `${name} ${name}-${id}`;
  const slidesHtml = (products || []).map(p => {
    const img = (p.images && p.images[0]) ? p.images[0].src : '';
    const title = (p.title || '').replace(/</g, '&lt;');
    const url = `/products/${p.handle}`;
    const price = p.variants && p.variants[0] ? String(p.variants[0].price) : '';
    const compare_at = p.variants && p.variants[0] ? String(p.variants[0].compare_at_price || '') : '';
    const discountHtml = (compare_at && parseFloat(compare_at) > parseFloat(price))
      ? `<div class="${common('ai-product-carousel__discount-badge', ai_gen_id)}">-${Math.round((1 - (price / compare_at)) * 100)}%</div>`
      : '';
    return `
      <div class="${common('ai-product-carousel__slide', ai_gen_id)}" style="box-sizing:border-box;padding:8px;min-width:200px;border:1px solid #ddd; border-radius:5px; overflow:hidden;">
        <div class="${common('ai-product-carousel__image-container', ai_gen_id)}" style="position:relative;">
          ${img ? `<img src="${img}" alt="${title}" class="${common('ai-product-carousel__image', ai_gen_id)}" loading="lazy" style="width:100%;height:160px;object-fit:cover;border-radius:8px;">` : `<div style="height:160px;background:#eee;border-radius:8px;"></div>`}
          ${discountHtml}
        </div>
        <div class="${common('ai-product-carousel__content', ai_gen_id)}" style="padding-top:8px;">
          <h3 class="${common('ai-product-carousel__title-product', ai_gen_id)}" style="font-size:13px;margin:0 0 6px;"><a href="${url}" style="text-decoration:none;color:inherit">${title}</a></h3>
          <div style="font-size:13px;">${compare_at && parseFloat(compare_at) > parseFloat(price) ? `<span style="font-weight:700;margin-right:8px;">₹${price}</span><span style="text-decoration:line-through;opacity:0.7;">₹${compare_at}</span>` : `<span>₹${price}</span>`}</div>
        </div>
      </div>
    `;
  }).join('');

  const slot = document.querySelector('#vnk-cartoon-modal #vnk-carousel-slot') || document.getElementById('vnk-carousel-slot');
  if (!slot) return;
  const wrapper = `
    <div class="ai-product-carousel ${common('ai-product-carousel', ai_gen_id)}" style="width:100%;overflow:hidden;">
      <div class="ai-product-carousel__container" style="position:relative;">
        <button class="ai-product-carousel__nav ai-product-carousel__nav--prev-${ai_gen_id}" aria-label="Previous" style="position:absolute;left:0;top:40%;z-index:10;background:transparent;border:0;font-size:26px;cursor:pointer;">‹</button>
        <div class="ai-product-carousel__track-${ai_gen_id}" style="display:flex;gap:12px;transition:transform 300ms ease;will-change:transform;padding:8px 40px;"></div>
        <button class="ai-product-carousel__nav ai-product-carousel__nav--next-${ai_gen_id}" aria-label="Next" style="position:absolute;right:0;top:40%;z-index:10;background:transparent;border:0;font-size:26px;cursor:pointer;">›</button>
      </div>
    </div>`; 
  slot.innerHTML = wrapper;
  const track = slot.querySelector(`.ai-product-carousel__track-${ai_gen_id}`);
  if (track) track.innerHTML = slidesHtml;
  // init the simple slider logic (re-use existing small init function if present)
  setTimeout(() => { try { initInjectedCarousel(ai_gen_id, slot); } catch(e){} }, 60);
 }


  // --- Carousel / render functions (restored horizontal carousel with unique IDs) ---
 
  async function renderCarouselForCollection(handle, slotEl) {
  // prefer modal slot if present
  const preferModalSlot = document.querySelector('#vnk-cartoon-modal #vnk-carousel-slot');
  const pageSlot = document.getElementById('vnk-carousel-slot');
  const slot = slotEl || preferModalSlot || pageSlot;
  if (!slot) {
    console.warn('No carousel slot available for', handle);
    return;
  }

  try {
    slot.innerHTML = `<div style="padding:16px;color:#666">Loading suggestions…</div>`;

    // 1) Get product handles quickly (REST is fine for handles)
    let restRes = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=20`);
    if (!restRes.ok) {
      slot.innerHTML = `<div style="color:#c00">Error loading ${handle} (${restRes.status})</div>`;
      return;
    }
    const restData = await restRes.json();
    const restProducts = (restData && restData.products) || [];
    const handles = restProducts.map(p => (p.handle || '').toString()).filter(Boolean).slice(0, 20);

    let products = null;
    const sfToken = window.__vnk_storefront_token__ || '';
    // 2) If token present, fetch metafields using productByHandle aliases with identifiers
    if (sfToken && handles.length) {
  try {
    // build productByHandle aliases
    const aliasBlocks = handles.map((h, i) => {
      return `p${i}: productByHandle(handle: ${JSON.stringify(h)}) {
        id
        handle
        title
        tags
        images(first:1) { nodes { url } }
        variants(first:1) { nodes { price { amount currencyCode } compareAtPrice { amount currencyCode } } }
        metafields(identifiers: [
          {namespace: "custom", key: "face_type"},
          {namespace: "custom", key: "necklines"},
          {namespace: "custom", key: "occasions"}
        ]) { key namespace value type }
      }`;
    }).join('\n');

    const gql = `query productsByHandles { ${aliasBlocks} }`;

    const fetchRes = await fetch('/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': sfToken
      },
      body: JSON.stringify({ query: gql })
    });

    const json = await fetchRes.json();

    // If server returned errors or no data, fail early with useful logs
    if (json.errors && json.errors.length) {
      console.warn('[vnk] GraphQL Errors:', json.errors);
      console.warn('[vnk] GraphQL full response:', json);
      throw new Error('GraphQL returned errors');
    }
    if (!json.data || typeof json.data !== 'object') {
      console.warn('[vnk] GraphQL returned no data:', json);
      throw new Error('GraphQL returned no data');
    }

    // Map aliases p0, p1... to our product shape defensively
    const data = json.data || {};
    products = handles.map((h, i) => {
      const node = data['p' + i] || null;
      if (!node) return null;

      // Build metafield map, skipping null entries
      const mfMap = {};
      if (Array.isArray(node.metafields)) {
        node.metafields.forEach(m => {
          if (!m) return; // skip nulls
          if (m.key) mfMap[m.key] = normalizeMetafieldValue(m.value, m.type);
        });
      } else if (node.metafields && Array.isArray(node.metafields.edges)) {
        node.metafields.edges.forEach(e => {
          const n = e && e.node;
          if (!n) return;
          if (n.key) mfMap[n.key] = normalizeMetafieldValue(n.value, n.type);
        });
      }

      // images
      const imgUrl = (node.images && node.images.nodes && node.images.nodes[0] && node.images.nodes[0].url) ? node.images.nodes[0].url : '';

      // variant price extraction (support object shape)
      let price = '';
      let compareAt = '';
      const v0 = node.variants && node.variants.nodes && node.variants.nodes[0];
      if (v0) {
        if (v0.price && typeof v0.price === 'object' && 'amount' in v0.price) price = v0.price.amount;
        else price = v0.price || '';
        if (v0.compareAtPrice && typeof v0.compareAtPrice === 'object' && 'amount' in v0.compareAtPrice) compareAt = v0.compareAtPrice.amount;
        else compareAt = v0.compareAtPrice || '';
      }

      return {
        id: node.id,
        handle: node.handle || h,
        title: node.title || '',
        tags: node.tags || [],
        images: imgUrl ? [{ src: imgUrl }] : [],
        variants: price ? [{ price: price, compare_at_price: compareAt || '' }] : [],
        metafields: { custom: {
          face_type: (mfMap['face_type'] || mfMap['face'] || '') + '',
          necklines: (mfMap['necklines'] || mfMap['neckline'] || '') + '',
          occasions: (mfMap['occasions'] || '') + ''
        }}
      };
    }).filter(Boolean);

    console.log('[vnk] GraphQL: loaded products with metafields:', products.length);
  } catch (e) {
    console.warn('GraphQL path failed, falling back to REST+enrichment:', e && e.message ? e.message : e, e && e.stack ? e.stack : '');
    products = null; // trigger fallback
  }
}


    // 3) Fallback: if GraphQL not used or failed, use REST + enrichment (existing logic)
    if (!products) {
      products = restProducts;
      if (typeof enrichProductsWithMeta === 'function') {
        try {
          products = await enrichProductsWithMeta(products, handle);
        } catch (e) { console.warn('enrichProductsWithMeta error', e); }
      }
    }

    // 4) Persist and normalize metafields for filtering (lowercase, comma-lists)
    window.__vnk_last_fetched_products__ = (products || []).map(p => {
      p.metafields = p.metafields || {};
      p.metafields.custom = p.metafields.custom || {};
      ['face_type','necklines','occasions'].forEach(k => {
        if (p.metafields.custom[k] === undefined || p.metafields.custom[k] === null) p.metafields.custom[k] = '';
        if (Array.isArray(p.metafields.custom[k])) p.metafields.custom[k] = p.metafields.custom[k].join(',');
        p.metafields.custom[k] = String(p.metafields.custom[k] || '').toLowerCase().trim();
      });
      return p;
    }).slice();

    window.__vnk_last_coll_handle__ = handle;

    // 5) Apply filters (prefer detected face if present)
    window.__vnk_filters__ = window.__vnk_filters__ || {};
    if (window.__vnk_last_face_type__) window.__vnk_filters__.face = String(window.__vnk_last_face_type__).toLowerCase();
    if (handle) {
  window.__vnk_filters__.collection = handle;
}

    const filtered = filterProducts(window.__vnk_last_fetched_products__ || [], window.__vnk_filters__ || {});
    const productsToRender = (filtered && filtered.length) ? filtered : [];

   // Force-hide necklines & occasions until explicitly requested by user
   // (keeps DOM structure but prevents any options from appearing)
   const neckOptions = [];
   const occOptions  = [];
   // still call renderer so event wiring/markup exists (no UI/CSS change)
   renderFilterTabs('vnk-neckline-tabs', neckOptions, 'neckline');
   renderFilterTabs('vnk-occasion-tabs',  occOptions,  'occasion');
   const necklineTabsEl = document.getElementById('vnk-neckline-tabs');
   const occasionTabsEl = document.getElementById('vnk-occasion-tabs');
   if (necklineTabsEl) necklineTabsEl.style.display = 'none';
   if (occasionTabsEl) occasionTabsEl.style.display = 'none';


    if (!productsToRender.length) {
      slot.innerHTML = `<div style="padding:12px;color:#666">No products match your filters.</div>`;
      const cta = document.getElementById('vnk-cta-btn');
      if (cta) cta.dataset.vnkTempHref = '';
      return;
    }

    // 6) Render carousel (existing UI code)
    const ai_gen_id = 'dyn_' + randomId();
    const common = (name, id) => `${name} ${name}-${id}`;

    const slidesHtml = productsToRender.map(p => {
      const img = (p.images && p.images[0]) ? p.images[0].src : '';
      const title = (p.title || '').replace(/</g, '&lt;');
      const url = `/products/${p.handle}`;
      const price = p.variants && p.variants[0] ? String(p.variants[0].price) : '';
      const compare_at = p.variants && p.variants[0] ? String(p.variants[0].compare_at_price || '') : '';
      const discountHtml = (compare_at && parseFloat(compare_at) > parseFloat(price))
        ? `<div class="${common('ai-product-carousel__discount-badge', ai_gen_id)}">-${Math.round((1 - (price / compare_at)) * 100)}%</div>`
        : '';
      return `
        <div class="${common('ai-product-carousel__slide', ai_gen_id)}" style="box-sizing:border-box;padding:8px;min-width:200px;border:1px solid #ddd; border-radius:5px; overflow:hidden;">
          <div class="${common('ai-product-carousel__image-container', ai_gen_id)}" style="position:relative;">
            ${img ? `<img src="${img}" alt="${title}" class="${common('ai-product-carousel__image', ai_gen_id)}" loading="lazy" style="width:100%;height:160px;object-fit:cover;border-radius:8px;">` : `<div class="${common('ai-product-carousel__placeholder', ai_gen_id)}" style="height:160px;background:#eee;border-radius:8px;"></div>`}
            ${discountHtml}
          </div>
          <div class="${common('ai-product-carousel__content', ai_gen_id)}" style="padding-top:8px;">
            <h3 class="${common('ai-product-carousel__title-product', ai_gen_id)}" style="font-size:13px;margin:0 0 6px;"><a href="${url}" style="text-decoration:none;color:inherit">${title}</a></h3>
            <div class="${common('ai-product-carousel__price', ai_gen_id)}" style="font-size:13px;">
              ${compare_at && parseFloat(compare_at) > parseFloat(price)
                ? `<span class="${common('ai-product-carousel__price-sale', ai_gen_id)}" style="font-weight:700;margin-right:8px;">₹${price}</span>
                   <span class="${common('ai-product-carousel__price-compare', ai_gen_id)}" style="text-decoration:line-through;opacity:0.7;">₹${compare_at}</span>`
                : `<span class="${common('ai-product-carousel__price-regular', ai_gen_id)}">₹${price}</span>`}
            </div>
          </div>
        </div>`;
    }).join('');

    const wrapper = `
      <div class="${common('ai-product-carousel', ai_gen_id)}" style="width:100%;overflow:hidden;">
        <div class="${common('ai-product-carousel__container', ai_gen_id)}" style="position:relative;">
          <button class="${common('ai-product-carousel__nav', ai_gen_id)} ai-product-carousel__nav--prev-${ai_gen_id}" aria-label="Previous" style="position:absolute;left:0;top:40%;z-index:10;background:transparent;border:0;font-size:26px;cursor:pointer;">‹</button>
          <div class="${common('ai-product-carousel__track', ai_gen_id)}" style="display:flex;gap:12px;transition:transform 300ms ease;will-change:transform;padding:8px 40px;"></div>
          <button class="${common('ai-product-carousel__nav', ai_gen_id)} ai-product-carousel__nav--next-${ai_gen_id}" aria-label="Next" style="position:absolute;right:0;top:40%;z-index:10;background:transparent;border:0;font-size:26px;cursor:pointer;">›</button>
        </div>
      </div>
    `;
    slot.innerHTML = wrapper;
    const track = slot.querySelector(`.ai-product-carousel__track-${ai_gen_id}`);
    if (track) track.innerHTML = slidesHtml;

    const styleId = 'ai-prod-carousel-style-' + ai_gen_id;
    if (!document.getElementById(styleId)) {
      const s = document.createElement('style');
      s.id = styleId;
      s.textContent = `
        .ai-product-carousel__discount-badge-${ai_gen_id} { position:absolute; left:8px; top:8px; background:#ff4d4f; color:#fff; padding:4px 6px; font-weight:700; border-radius:6px; font-size:12px; }
      `;
      document.head.appendChild(s);
    }

    initInjectedCarousel(ai_gen_id, slot);

  } catch (err) {
    console.error('renderCarouselForCollection error', err);
    slot.innerHTML = `<div style="color:#c00">Failed to load ${handle}</div>`;
  }
}

  
  window.renderCarouselForCollection = renderCarouselForCollection;

  function initInjectedCarousel(ai_gen_id, root) {
    const track = root.querySelector(`.ai-product-carousel__track-${ai_gen_id}`);
    const slides = root.querySelectorAll(`.ai-product-carousel__slide-${ai_gen_id}`);
    const prev = root.querySelector(`.ai-product-carousel__nav--prev-${ai_gen_id}`);
    const next = root.querySelector(`.ai-product-carousel__nav--next-${ai_gen_id}`);
    let idx = 0;

    function slideWidth() {
      const s = slides[0];
      return s ? s.getBoundingClientRect().width : 260;
    }
    function update() {
      const w = slideWidth();
      const visible = Math.max(1, Math.floor((root.getBoundingClientRect().width - 80) / (w + 12)));
      const translateX = -(idx * (w + 12));
      if (track) track.style.transform = `translateX(${translateX}px)`;
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx >= slides.length - visible;
    }
    prev && prev.addEventListener('click', () => { idx = Math.max(0, idx - 1); update(); });
    next && next.addEventListener('click', () => { idx = Math.min(slides.length - 1, idx + 1); update(); });
    window.addEventListener('resize', update);
    setTimeout(update, 60);
  }

  // ===== LOADER (DOM helpers) =====
  const LOADER_DURATION_MS = 5000;

  function createLoaderElement() {
    const container = document.createElement('div');
    container.id = 'vnk-loader-container';
    container.setAttribute('aria-live', 'polite');
    container.innerHTML = `
      <div id="vnk-loader-wrap" role="status" aria-label="Analyzing your face Aura">
        <div id="vnk-loader-msg"></div>
        <div id="vnk-loader-bar"><div id="vnk-loader-fill"></div></div>
      </div>
    `;
    return container;
  }

  function animateLoader(fillEl, durationMs) {
    return new Promise((resolve) => {
      const start = performance.now();
      function step(now) {
        const t = Math.min(1, (now - start) / durationMs);
        fillEl.style.width = (t * 100) + '%';
        if (t < 1) requestAnimationFrame(step);
        else resolve();
      }
      requestAnimationFrame(step);
    });
  }

  function waitForPromiseWithTimeout(promise, timeoutMs = 8000) {
    return Promise.race([

      promise,
      new Promise(res => setTimeout(() => res(null), timeoutMs))
    ]);
  }

  // ===== Main flow =====
  (async () => {
    log('Starting main flow');
    const root = await waitFor(() => document.querySelector('#earring-sg'));
    const API_BASE = root.dataset.apiBase || '';
    const COLLECTIONS = getCollectionsMap(root);
    // restore persisted style profile (if any)
// STEP 6 — EARLY EXIT FOR RETURNING USERS
try {
  const profile = loadStyleProfile();
if (profile && profile.face) {

  // restore globals
  window.__vnk_last_face_type__ = profile.face;
  window.__vnk_filters__ = window.__vnk_filters__ || {};
  window.__vnk_filters__.face = profile.face;

  if (profile.last_collection) {
    window.__vnk_filters__.collection = profile.last_collection;
    window.__vnk_last_coll_handle__ = profile.last_collection;
  }

  // ✅ STEP 6.1 — create modal shell (NO image)
  await showPreviewModal(null, {
  title: profile.title || 'Style suggestion',
  subtitle: profile.subtitle || 'Based on your face shape',
  autoCloseMs: null,
  collHandle: window.__vnk_last_coll_handle__ || null
});


  if (window.__vnk_last_coll_handle__) {
  await renderCarouselForCollection(window.__vnk_last_coll_handle__);
  if (typeof applyFiltersAndRender === 'function') applyFiltersAndRender();
}


  return; // 🚨 stop camera + rest of init
}


} catch (e) {
  console.warn('Profile reuse failed, falling back to camera', e);
}


    log('API_BASE', API_BASE, 'Collections map', COLLECTIONS);

    // edit 1: store for last detected collection handle so CTA can use it
    window.__vnk_last_coll_handle__ = null; // edit 1

    const video = root.querySelector('.vnk-video');
    const canvas = root.querySelector('#vnk-overlay');
    const ctx = canvas ? canvas.getContext('2d') : null;
    const elResult = root.querySelector('#vnk-result');
    const freezeNote = root.querySelector('#vnk-freezeNote');
    const resetBtn = root.querySelector('#vnk-reset');

    // store video reference
    window.__vnk_video_reference__ = video;

    try {
      log('Requesting camera');
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false });
      video.srcObject = stream;
      await video.play().catch(e => log('video.play error', e));
      if (canvas) { canvas.width = video.videoWidth || 1280; canvas.height = video.videoHeight || 720; }
      log('Camera ready', canvas ? canvas.width : 'no-canvas', video.videoWidth, video.videoHeight);
    } catch (e) {
      console.error('Camera access error', e);
      if (elResult) elResult.textContent = 'Camera blocked.';
      return;
    }

    function drawOverlay() { if (ctx && canvas) ctx.clearRect(0, 0, canvas.width, canvas.height); }

    // captureAndSend used by delegated shutter as well
    window.captureAndSend = async function () {
      log('captureAndSend triggered');
      drawOverlay();
      const blob = await captureFrameBlob(video);
      if (!blob) { log('No blob captured'); return null; }
      log('Blob captured', blob.size);
      const modalEl = document.getElementById('vnk-cartoon-modal');
      const unifiedResultEl = (modalEl && modalEl.querySelector('#vnk-result')) || elResult || document.querySelector('#vnk-result');

      try {
        if (unifiedResultEl) unifiedResultEl.textContent = 'Sending image…';
        const fd = new FormData();
        fd.append('file', blob, 'frame.jpg');
        const r = await fetch((API_BASE + '/detect/face-shape').replace(/\/+$/, ''), { method: 'POST', body: fd });
        log('API response status', r.status);
        if (!r.ok) {
          if (unifiedResultEl) unifiedResultEl.textContent = 'Server error. Please try again.';
          if (freezeNote) freezeNote.style.display = 'none';
          return null;
        }
        const json = await r.json();
        if (unifiedResultEl) unifiedResultEl.textContent = 'Detected: ' + String(json.face_shape || '').toUpperCase();
        window.dispatchEvent(new CustomEvent('vnk:faceDetected', { detail: json }));

        // persist style profile
if (json && json.face_shape) {
  const face = String(json.face_shape).toLowerCase();

  const lastCollection =
    window.__vnk_filters__?.collection ||
    window.__vnk_last_coll_handle__ ||
    null;

  saveStyleProfile({
    face,
    collection: lastCollection
  });
}

        if (freezeNote) freezeNote.style.display = 'block';

        // edit 5 (CHANGED) — persist detected face only; DO NOT map face -> collection
        if (json && json.face_shape) { // edit 5
          const face = String(json.face_shape).toLowerCase();

          // Persist detected face into the filter pipeline (only)
          window.__vnk_last_face_type__ = face;
          window.__vnk_filters__ = window.__vnk_filters__ || {};
          window.__vnk_filters__.face = face;

          // Which collection to fetch? prefer user-selected collection, else last_coll_handle (do NOT derive from face)
          const collHandle = (window.__vnk_filters__.collection && window.__vnk_filters__.collection.length)
                              ? window.__vnk_filters__.collection
                              : (window.__vnk_last_coll_handle__ || null);

          if (collHandle) {
            await renderCarouselForCollection(collHandle);
            if (typeof applyFiltersAndRender === 'function') applyFiltersAndRender();
          } else {
            if (typeof applyFiltersAndRender === 'function') applyFiltersAndRender();
          }
        } // edit 5

        return json;
      } catch (e) {
        console.error('captureAndSend -> send error', e);
        if (unifiedResultEl) unifiedResultEl.textContent = 'Network error. Please try again.';
        if (freezeNote) freezeNote.style.display = 'none';
        return null;
      }
    };

    function stopCameraStream() {
      try {
        const s = video && video.srcObject;
        if (s && s.getTracks) {
          s.getTracks().forEach(t => { try { t.stop(); } catch (e) { } });
        }
        if (video) { try { video.pause(); } catch (e) { } try { video.srcObject = null; } catch (e) { } }
        log('Camera stream stopped');
      } catch (e) { log('stopCameraStream error', e); }
    }

    // --- New delegated shutter (canonical high-res + downscale cartoon in parallel) ---
    if (!window.__vnk_delegated_shutter_installed__) {
      window.__vnk_delegated_shutter_installed__ = true;
      let isProcessing = false;

      async function downscaleBlob(blob, maxSide = 512, mime = 'image/jpeg', quality = 0.85) {
        return new Promise((res, rej) => {
          try {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            const url = URL.createObjectURL(blob);
            img.onload = async () => {
              try {
                const W = img.width, H = img.height;
                const scale = Math.min(1, maxSide / Math.max(W, H));
                const sw = Math.round(W * scale), sh = Math.round(H * scale);
                const c = document.createElement('canvas');
                c.width = sw; c.height = sh;
                const ctx2 = c.getContext('2d');
                // mirror for selfie consistency
                ctx2.translate(sw, 0); ctx2.scale(-1, 1);
                ctx2.drawImage(img, 0, 0, sw, sh);
                c.toBlob(b => {
                  URL.revokeObjectURL(url);
                  res(b);
                }, mime, quality);
              } catch (e) { URL.revokeObjectURL(url); rej(e); }
            };
            img.onerror = (e) => { URL.revokeObjectURL(url); rej(e); };
            img.src = url;
          } catch (err) { rej(err); }
        });
      }

      function withTimeout(p, ms, errMsg = 'timeout') {
        return Promise.race([p, new Promise((_, rej) => setTimeout(() => rej(new Error(errMsg)), ms))]);
      }

      document.addEventListener('click', async (ev) => {
        const btn = ev.target && ev.target.closest ? ev.target.closest('#vnk-capture') : null;
        if (!btn) return;
        if (isProcessing) { log('Click ignored — already processing'); return; }
        isProcessing = true;

        try {
          log('Shutter clicked — parallel canonical capture + downscale cartoon');
          const startTs = Date.now();
          // hide UI affordances quickly if present
          try { const oval = root.querySelector('#vnk-face-oval'); if (oval) oval.style.display = 'none'; } catch (e) { }
          try { btn.style.display = 'none'; btn.style.pointerEvents = 'none'; } catch (e) { }

          // canonical high-res blob for API
          const canonicalBlob = await captureFrameBlob(video); // default downscaleTo = 1024
          if (!canonicalBlob) throw new Error('Failed to capture frame');

          // cartoon downscale (non-blocking)
          const cartoonBlobPromise = downscaleBlob(canonicalBlob, 512).catch(err => {
            log('downscale failed, fallback to canonical blob for cartoon', err);
            return canonicalBlob; // fallback
          });

          // show loader (assumes CSS for loader exists in external file)
          const loaderEl = createLoaderElement();
          const parent = btn.parentElement || document.body;
          parent.appendChild(loaderEl);
          const msgEl = loaderEl.querySelector('#vnk-loader-msg');
          const messages = ["Analyzing your face aura", "Finding your sweet spot"];
          let idx = 0;
          msgEl.textContent = messages[idx];
          const msgInterval = setInterval(() => { idx = (idx + 1) % messages.length; msgEl.textContent = messages[idx]; }, 1000);
          const fillEl = loaderEl.querySelector('#vnk-loader-fill');

          // looped animate loader until we clear it
          let stopLoader = false;
          (function loopAnimate() {
            if (stopLoader) return;
            try { fillEl.style.width = '0%'; } catch (e) { }
            animateLoader(fillEl, LOADER_DURATION_MS).then(() => {
              if (!stopLoader) loopAnimate();
            }).catch(() => { if (!stopLoader) setTimeout(loopAnimate, 200); });
          })();

          // parallel tasks
          const apiPromise = (async () => {
            try {
              const fd = new FormData();
              fd.append('file', canonicalBlob, 'frame.jpg');
              const url = (API_BASE + '/detect/face-shape').replace(/\/+$/, '');
              const r = await fetch(url, { method: 'POST', body: fd });
              log('API response status', r.status);
              if (!r.ok) throw new Error('Server non-ok: ' + r.status);
              const json = await r.json();
              return json;
            } catch (e) { throw e; }
           })();

           const previewPromise = (async () => {
  const pBlob = await cartoonBlobPromise;
  const previewUrl = URL.createObjectURL(pBlob);
  return { previewUrl, isObjectUrl: true };
})();



           const PREVIEW_TIMEOUT = 7000; // match original cartoon timeout
const API_TIMEOUT = 7000;
const OVERALL_TIMEOUT = 8000;

let apiResult = null, previewObj = null;

try {
  const both = Promise.all([
    withTimeout(apiPromise, API_TIMEOUT, 'api timeout'),
    withTimeout(previewPromise, PREVIEW_TIMEOUT, 'preview timeout')
  ]);
  const [apiR, previewR] = await Promise.race([both, new Promise((_, rej) => setTimeout(() => rej(new Error('overall timeout')), OVERALL_TIMEOUT))]);
  apiResult = apiR;
  previewObj = previewR;
} catch (e) {
  log('One or more tasks timed out or overall timeout occurred', e);
  try { apiResult = await Promise.race([apiPromise.catch(() => null), Promise.resolve(null)]); } catch (e2) { apiResult = null; }
  try { previewObj = await Promise.race([previewPromise.catch(() => null), Promise.resolve(null)]); } catch (e2) { previewObj = null; }
}


          // Ensure minimum display time before proceeding
          const MIN_DISPLAY_MS = 5000;
          const elapsed = Date.now() - startTs;
          if (elapsed < MIN_DISPLAY_MS) {
            await new Promise(res => setTimeout(res, MIN_DISPLAY_MS - elapsed));
          }

          // stop loader
          stopLoader = true;
          clearInterval(msgInterval);
          try { if (loaderEl && loaderEl.parentElement) loaderEl.parentElement.removeChild(loaderEl); } catch (e) { }

           if (apiResult && previewObj && previewObj.previewUrl) {
  const subtitle = apiResult.msg || ('Detected: ' + (apiResult.face_shape || '').toUpperCase());

  // persist detected face only; do NOT map face -> collection
  try {
    const face = (apiResult.face_shape || '').toLowerCase();
    // persist detected face into filter state (do NOT derive collection from face)
    window.__vnk_last_face_type__ = face;
    window.__vnk_filters__ = window.__vnk_filters__ || {};
    window.__vnk_filters__.face = face;
    

    // prefer an already selected collection or last_coll_handle; do NOT compute from face
    const collToUse = (window.__vnk_filters__.collection && window.__vnk_filters__.collection.length)
                      ? window.__vnk_filters__.collection
                      : (window.__vnk_last_coll_handle__ || null);
    window.__vnk_last_coll_handle__ = window.__vnk_last_coll_handle__ || collToUse || null;
    
    saveStyleProfile({
  face,
  collection: collToUse,
  title: apiResult.title || 'Style suggestion',
  subtitle: apiResult.message || subtitle
});



    // show modal with the real captured photo (previewObj.previewUrl is an object URL or data URL)
    showPreviewModal(previewObj.previewUrl, {
      title: apiResult.title || 'Style suggestion',
      subtitle: apiResult.message || subtitle,
      autoCloseMs: null,
      collHandle: collToUse
    }).catch(() => {});

    // if a collection is available, fetch it so filtering by product.metafields is possible
    if (collToUse) {
      try { await renderCarouselForCollection(collToUse); } catch (e) { log('renderCarousel error', e); }
      try { if (typeof applyFiltersAndRender === 'function') applyFiltersAndRender(); } catch (e) { /* ignore */ }
    }
  } catch (e) {
    log('showPreviewModal errored', e);
  }

  // STOP CAMERA: results are shown and suggestions rendered
  try { stopCameraStream(); } catch (e) { log('stopCameraStream error', e); }

  // Revoke preview object URL after a short delay to avoid leaking memory (only if it was an object URL)
  if (previewObj && previewObj.previewUrl && previewObj.isObjectUrl) {
    setTimeout(() => { try { URL.revokeObjectURL(previewObj.previewUrl); } catch (e) { } }, 7000);
  }
}
  else {
  // fallback policies
  if (previewObj && previewObj.previewUrl && !apiResult) {
    showPreviewModal(previewObj.previewUrl, { 
      title: 'Preview — your real capture', 
      subtitle: 'Analyzing…', 
      autoCloseMs: null 
    }).catch(() => { });
    try { stopCameraStream(); } catch (e) { log('stopCameraStream error', e); }
  } else if (apiResult && (!previewObj || !previewObj.previewUrl)) {
    try {
      const obj = URL.createObjectURL(canonicalBlob);
      const subtitle = apiResult.msg || ('Detected: ' + (apiResult.face_shape || '').toUpperCase());

      try {
        const face = (apiResult.face_shape || '').toLowerCase();
        window.__vnk_last_face_type__ = face;
        window.__vnk_filters__ = window.__vnk_filters__ || {};
        window.__vnk_filters__.face = face;

        const collToUse = (window.__vnk_filters__.collection && window.__vnk_filters__.collection.length)
                          ? window.__vnk_filters__.collection
                          : (window.__vnk_last_coll_handle__ || null);
        window.__vnk_last_coll_handle__ = window.__vnk_last_coll_handle__ || collToUse || null;

        saveStyleProfile({
  face,
  collection: collToUse,
  title: apiResult.title || 'Style suggestion',
  subtitle: apiResult.message || subtitle
});


        showPreviewModal(obj, {
          title: 'Preview — your real capture',
          subtitle,
          autoCloseMs: null,
          collHandle: collToUse
        }).catch(() => { });
      } catch (e) {
        showPreviewModal(obj, { title: 'Preview — your real capture', subtitle, autoCloseMs: null }).catch(() => { });
      }

      setTimeout(() => { try { URL.revokeObjectURL(obj); } catch (e) { } }, 7000);
    } catch (e) { log('fallback photo show error', e); }
    
    try {
      const collToUse = (window.__vnk_filters__.collection && window.__vnk_filters__.collection.length)
                        ? window.__vnk_filters__.collection
                        : (window.__vnk_last_coll_handle__ || null);
      if (collToUse) await renderCarouselForCollection(collToUse);
    } catch (e) { log('renderCarousel error', e); }
    try { stopCameraStream(); } catch (e) { log('stopCameraStream error', e); }
  } else {
    const errMsg = 'Unable to generate preview right now. Please try again.';
    const modalEl = document.getElementById('vnk-cartoon-modal');
    const resultEl = (modalEl && modalEl.querySelector('#vnk-result')) || elResult || document.querySelector('#vnk-result');
    if (resultEl) resultEl.textContent = errMsg;
    try { stopCameraStream(); } catch (e) { log('stopCameraStream error', e); }
  }
}


          log('Parallel flow finished');
        } catch (err) {
          console.error('Shutter flow error', err);
          // best-effort restore UI
          try {
            const fallbackBtn = root.querySelector('#vnk-capture');
            if (fallbackBtn) { fallbackBtn.style.display = ''; fallbackBtn.style.pointerEvents = ''; }
            const fallbackOval = root.querySelector('#vnk-face-oval');
            if (fallbackOval) fallbackOval.style.display = '';
          } catch (e) { }
        } finally {
          isProcessing = false;
        }
      }, false);

      log('Delegated shutter handler installed (parallel canonical capture + downscale cartoon)');
    }

    log('Main flow booted — handlers installed');

    // optional reset button behaviour
    resetBtn?.addEventListener('click', () => {
      if (elResult) elResult.textContent = 'Waiting for face…';
      if (freezeNote) freezeNote.style.display = 'none';
      const slot = document.getElementById('vnk-carousel-slot');
      if (slot) slot.innerHTML = '';
    });
  })();

})();
